/* eslint @typescript-eslint/prefer-nullish-coalescing: 1 -- Do not want to break existing code by switching to nullish coalesce blidnly */
import { useFeatureFlagsContext } from '../contexts/FeatureFlagsProvider';

const useFeatureFlag = (featureFlagKey: string): boolean => {
  const { data, isSuccess } = useFeatureFlagsContext();
  return (isSuccess && data[featureFlagKey]) ?? false;
};

export default useFeatureFlag;
